export default __webpack_public_path__ + "static/media/check.ddae4d5c.svg";